export const APP_FEATURE_BASE_OBJECT = {
  title: '',
  description: '',
}
